import { Row, Col, Typography, Button } from 'antd'
import { useNavigate } from 'react-router-dom'
import { isLocked } from '../../config/constants'

// import { playerInterfaceData } from '../../pages/mockData'
import {
  ActivateFromPracticeSquad,
  AuctionPlayer,
  MoveToInjured,
  ReleasePlayer,
  MoveToPracticeSquad,
  TradePlayer,
  PoachPlayer,
  MoveToReserve,
} from '../../components/modal/PlayerInterfaceModals'

const GmCard = (props) => {
  const {
    isButton,
    bidWinningPage = false,
    playerData: data,
    activePlayers,
    practicePlayers,
    getData,
    isAction = true,
    isReserve,
    reservedPlayers,
    news,
    // isViewer,
  } = props

  const navigate = useNavigate()

  return (
    <section className='player_info_box_new'>
      <div className='header_background'></div>
      <Row gutter={[30, 20]}>
        <Col xs={24} xl={10}>
          <div
            className='left'
            style={{
              // background: `url(${HostedHeadshotNoBackgroundUrl})`,
              position: 'relative',
            }}
          >
            <div>
              <Typography.Title level={2}>{data?.player_id?.Name}</Typography.Title>
              <div className='player-active-status'>
                <div className='active'>
                  <div className={data?.player_id?.isActive ? `active_btn` : 'in-active_btn'} />
                  <p>{data?.player_id?.isActive ? 'Active Player' : 'In-active Player'}</p>
                </div>
                <div className='injury-status'>
                  <p>Injury Status</p>
                  <h4
                    style={{
                      color:
                        data?.player_id?.InjuryStatus?.toLowerCase() == 'out'
                          ? 'red !important'
                          : '#00c008',
                    }}
                    className={`${
                      data?.player_id?.InjuryStatus?.toLowerCase() == 'out'
                        ? 'redColor'
                        : 'greenColor'
                    }`}
                  >
                    {data?.player_id?.InjuryStatus || '-'}
                  </h4>
                </div>
              </div>
            </div>
            <div className='box'>
              <p className='text1'>Position Rank:</p>
              <p className='text2'>
                #{data?.player_id?.PositionRank > 0 ? data?.player_id?.PositionRank : 0}
              </p>
            </div>
            <div className='box'>
              <p className='text1'>League Rank:</p>
              <p className='text2'>
                #{data?.player_id?.LeagueRank > 0 ? data?.player_id?.LeagueRank : 0}
              </p>
            </div>
            <div className='roster_player_image'>
              <img src={data?.player_id?.HostedHeadshotNoBackgroundUrl} />
            </div>
          </div>
        </Col>
        <Col xs={24} xl={isAction ? 10 : 14}>
          {isButton && (
            <Button type='primary' style={{ marginLeft: 'auto', display: 'flex' }}>
              AUCTION PLAYER
            </Button>
          )}

          <div className='player-news '>
            <Typography.Title level={3}>{`Player News`}</Typography.Title>
            <div className='player_news_scroll'>
              <p>{news || '-'}</p>
            </div>
          </div>

          <div className='stats-bar'>
            <div className='player-news' style={{ marginTop: '0px' }}>
              <p>Past Year Stats Bar</p>
              <div className='years'>
                <Typography.Title level={2}>2023</Typography.Title>
                <Typography.Title level={2}>2022</Typography.Title>
                <Typography.Title level={2}>2021</Typography.Title>
              </div>
            </div>
            {data?.player_id?.team?.logo && (
              <img src={data?.player_id?.team?.logo} height={'100px'} />
            )}
          </div>
        </Col>
        {isAction && (
          <Col xs={24} xl={4}>
            {bidWinningPage ? (
              <div className='action-bar'>
                <h4>Player Action Bar</h4>
                <Button
                  type='primary'
                  className='action-bar-btn'
                  onClick={() => {
                    navigate('/team-trade')
                  }}
                >
                  make offer
                </Button>
                <PoachPlayer />
              </div>
            ) : isLocked() ? (
              <></>
            ) : (
              <div className='action-bar'>
                <h4>Player Action Bar</h4>

                <AuctionPlayer
                  disabled={data?.isPlayerLocked}
                  playerIds={{
                    PlayerID: data?.player_id?.PlayerID,
                    player_id: data?.player_id?._id,
                  }}
                />

                <TradePlayer disabled={data?.isPlayerLocked} />

                <ReleasePlayer disabled={data?.isPlayerLocked} playerId={data?.player_id?._id} />

                {isReserve && (
                  <MoveToReserve
                    disabled={data?.isReserved || data?.isPlayerLocked}
                    playerId={data?.player_id?._id}
                    reservedPlayers={reservedPlayers?.length}
                  />
                )}

                <MoveToInjured
                  disabled={
                    data?.player_id?.InjuryStatus?.toLowerCase() != 'out' || data?.isPlayerLocked
                  }
                  playerId={data?.player_id?._id}
                  getData={getData}
                />

                <ActivateFromPracticeSquad
                  disabled={!data?.inPracticeSquad || data?.isPlayerLocked}
                  playerId={data?.player_id?._id}
                  getData={getData}
                  activePlayers={activePlayers}
                />

                <MoveToPracticeSquad
                  disabled={data?.inPracticeSquad || data?.isPlayerLocked}
                  playerId={data?.player_id?._id}
                  getData={getData}
                  activePlayersCount={activePlayers?.length}
                  practicePlayers={practicePlayers}
                />
              </div>
            )}
          </Col>
        )}
      </Row>
    </section>
  )
}

export default GmCard
